export var APP_NAME_ALREADY_EXIST = new Error('this appName already exist in app registry.');
export var MISSING_APP_NAME = new Error('missing appName param in registerApp.');
export var MISSING_COMPONENT = new Error('missing component param in registerApp.');
//# sourceMappingURL=errors.js.map